import { render, staticRenderFns } from "./OneContest.vue?vue&type=template&id=b9c9231c&scoped=true&"
import script from "./OneContest.vue?vue&type=script&lang=js&"
export * from "./OneContest.vue?vue&type=script&lang=js&"
import style0 from "./OneContest.vue?vue&type=style&index=0&id=b9c9231c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c9231c",
  null
  
)

export default component.exports